export interface CurrenciesClass{
    AccountCurrencyId: number
    AccountCurrencyExchangeRateId: number
    SystemCurrencyId: number
    CurrencyCode:string
    Currency:string
    ExchangeRate:number
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    Disabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    IsUpdateExistingRecords:boolean
    isSelected:number
}


const common = {    
    AccountCurrencyId: 0,
    AccountCurrencyExchangeRateId: 0,
    SystemCurrencyId: 0,
    CurrencyCode:"",
    Currency:"",
    ExchangeRate:0,
    Disabled:false,
    IsUpdateExistingRecords:false
  };
  
  export const CurrenciesInitialsForAdd = { ...common };
  
  export const CurrenciesInitialsForUpdate = {
    ...common
    
  };
  


// export const CurrenciesInitialsForAdd = {
//     AccountCurrencyId: 0,
//     //AccountCurrencyExchangeRateId: 0,
//     SystemCurrencyId: 0,
//     CurrencyCode:"",
//     Currency:"",
//     ExchangeRate:0,
//     Disabled:false,
//     IsUpdateExistingRecords:false
    
// }

// export const CurrenciesInitialsForUpdate = {
//     AccountCurrencyId: 0,
//     AccountCurrencyExchangeRateId: 0,
//     SystemCurrencyId: 0,
//     CurrencyCode:"",
//     Currency:"",
//     ExchangeRate:0,
//     Disabled:false,
//     IsUpdateExistingRecords:false

// }